export const ACTION = {
    LOGIN: 'LOGIN',
    LOGOUT: 'LOGOUT',
    CHANGE_CULTURE: 'CHANGE_CULTURE',
    CHANGE_APPLICATION_TOKEN: 'CHANGE_APPLICATION_TOKEN',
    CHANGE_USER_TOKEN: 'CHANGE_USER_TOKEN',
    OPEN_POPUP: 'OPEN_POPUP',
    CLOSE_POPUP: 'CLOSE_POPUP',
    UPDATE_POPUP_TITLE: 'UPDATE_POPUP_TITLE',
    CLOSE_ALL_POPUPS: 'CLOSE_ALL_POPUPS',
    SET_LIST_STATE: 'SET_LIST_STATE',
    CLEAR_LIST_STATES: 'CLEAR_LIST_STATES',
    SET_PENDING_LIST_STATE: 'SET_PENDING_LIST_STATE',
    STORAGE_CHANGE: 'STORAGE_CHANGE',
    SET_LOADERS: 'SET_LOADERS',
    ENABLE_SERVICE_CONTRACT_CHANGE: "ENABLE_SERVICE_CONTRACT_CHANGE",
    CHANGE_MAINTENANCE: "CHANGE_MAINTENANCE"
}

export const login = (payload) => ({
    type: ACTION.LOGIN,
    payload
});

export const logout = () => ({
    type: ACTION.LOGOUT,
});

export const changeCulture = payload => ({
    type: ACTION.CHANGE_CULTURE,
    data: payload
});

export const changeMaintenance = payload => ({
    type: ACTION.CHANGE_MAINTENANCE,
    data: payload
});

export const changeApplicationToken = payload => ({
    type: ACTION.CHANGE_APPLICATION_TOKEN,
    data: payload
});

export const changeUserToken = payload => ({
    type: ACTION.CHANGE_USER_TOKEN,
    data: payload
});

export const openPopup = payload => ({
    type: ACTION.OPEN_POPUP,
    data: payload
});
export const closePopup = payload => ({
    type: ACTION.CLOSE_POPUP,
    windowKey: payload
});

export const updatePopupTitle = payload => ({
    type: ACTION.UPDATE_POPUP_TITLE,
    title: payload.title,
    windowKey: payload.windowKey
});

export const closeAllPopups = () => ({
    type: ACTION.CLOSE_ALL_POPUPS
});

export const setListState = payload => ({
    type: ACTION.SET_LIST_STATE,
    payload
});

export const clearListStates = () => ({
    type: ACTION.CLEAR_LIST_STATES
});

export const storageChange = (payload) => ({
    type: ACTION.STORAGE_CHANGE,
    //payload
});

export const enableServiceContractChange = (payload) => ({
    type: ACTION.ENABLE_SERVICE_CONTRACT_CHANGE,
    payload
});

export const setLoaders = payload => ({
    type: ACTION.SET_LOADERS,
    payload
});
